import { Styles } from "../../../../types/common";

const styles: Styles = {
  label: {
    fontSize: "14px",
    color: "#54565A",
    marginBottom: "8px",
  },
};

export default styles;
